export class ckConfig {
    ckConfig: object =
        {
            allowedContent: true,
            extraPlugins: 'divarea,colorbutton,justify,font,copyformatting,colordialog,dialog,dialogui,textShadow,selectall,pagebreak',
            textShadow_minValue : -50,
            textShadow_maxValue : 50,
            enterMode: 2,
            removeButtons: 'Flash,Smiley,HorizontalRule,SpecialChar,PageBreak,Iframe,Save,Form,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,SpellChecker,Scayt,NewPage,Preview,Print,Templates,About',
            removePlugins: 'elementspath', // Removes the element path that causes unwanted HTML tags in the footer
            coreStyles_bold: { element: 'b', overrides: 'strong' },
            coreStyles_italic: { element: 'i', overrides: 'em' },
            coreStyles_strike: { element: 'strike', overrides: 's' },
            disableNativeSpellChecker:false
        };
    fullEditorConfig:object = 
        {
            allowedContent: true,
            extraPlugins: 'preview,divarea,colorbutton,justify,font,copyformatting,colordialog,dialog,dialogui,textShadow,docprops,embed,autoembed,image2,selectall,pagebreak',
            textShadow_minValue : -50,
            textShadow_maxValue : 50,
            enterMode: 2,
            removeButtons: 'Flash,PageBreak,Save,Form,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Scayt,NewPage,Print,Templates,About',
            coreStyles_bold: { element: 'b', overrides: 'strong' },
            coreStyles_italic: { element: 'i', overrides: 'em' },
            coreStyles_strike: { element: 'strike', overrides: 's' },
            fullPage: true,
            height: 320,
            // Setup content provider. See https://ckeditor.com/docs/ckeditor4/latest/features/media_embed
            embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',

            // Configure the Enhanced Image plugin to use classes instead of styles and to disable the
            // resizer (because image size is controlled by widget styles or the image takes maximum
            // 100% of the editor width).
            image2_alignClasses: ['image-align-left', 'image-align-center', 'image-align-right'],
            image2_disableResizer: true,
            basicEntities : false,
            entities : false,
            entities_greek : false,
            entities_latin : false,
            htmlEncodeOutput : false,
            entities_processNumerical : false,
            disableNativeSpellChecker:false
    }

}